import axiosClient from './axiosClient';
import { IApiBaseResponse } from '~/utils/interface/common';
import {
  IEditCompanyRole,
  IParamsGetCompanyRoles,
  IPayloadDeleteCompanyRole,
  IResponseGetCompanyRoleDetail,
  IResponseGetCompanyRoles,
} from '~/utils/interface/company-role';

const companyRoleApi = {
  getCompanyRoles(params: IParamsGetCompanyRoles) {
    return axiosClient.get<IApiBaseResponse<IResponseGetCompanyRoles>>('api/admin/company-roles', { params });
  },

  createCompanyRole(data: IEditCompanyRole) {
    return axiosClient.post<IApiBaseResponse<IResponseGetCompanyRoleDetail>>('api/admin/company-roles', data);
  },

  getCompanyRole(id: string) {
    return axiosClient.get<IApiBaseResponse<IResponseGetCompanyRoleDetail>>(`api/admin/company-roles/${id}`);
  },

  updateCompanyRole(id: string | number, data: IEditCompanyRole) {
    return axiosClient.put<IApiBaseResponse<null>>(`api/admin/company-roles/${id}`, data);
  },

  deleteCompanyRole(data: IPayloadDeleteCompanyRole) {
    const url = `api/admin/company-roles`;
    return axiosClient.delete<IApiBaseResponse<null>>(url, { data });
  },

  getSelect() {
    return axiosClient.get<IApiBaseResponse<IResponseGetCompanyRoles>>('api/admin/company-roles/select');
  },
};

export default companyRoleApi;
